import React, { useEffect, useCallback } from 'react'
import { toast } from 'react-toastify';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import SideStyle from '../style/sideStyle';
//import FormAlign_0 from './formAlign_0';
import FormAlign_0 from '../formAk/formAlign_0';
import FormAlign_1 from './formAlign_1';
import FormAlign_2 from './formAlign_2';
import FormAlign_3 from './formAlign_3';
import Param from '../store/param';
import Control from '../store/control';

const Form = () => {
  const align    = Param.Get("align");

  switch (align.step) {
    case 0:
      return <FormAlign_0/>; // Angle
    case 1:
      return <FormAlign_1/>; // Set MPT
    case 2:
      return <FormAlign_2/>; // PTB Bar
    case 3:
      return <FormAlign_3/>; // Center
    default:
      return 'Unknown step';
  }
}

// Alignment
const FormAlign = () => {
  const SetCameraFront  = Control.Get("SetCameraFront");
  const SetCameraBack  = Control.Get("SetCameraBack");
  
  const style      = SideStyle();
  const align      = Param.Get("align");
  const setParam   = Param.Get("setParam");

  var text = "";

  useEffect(() => {
    toast('Adjust angle to align the cener of the object.')
    SetCameraFront();
  }, [])
  
  const onClick = useCallback((val) => {
    setParam(s => {s.align.step = val});

    if (val==0) {
      toast('Set angle of 3D model, and push [SET MPT].');
    } else if (val==1) {
      toast('Click on the MPT level, and push [PTB BAR].');
    } else if (val==2) {
      toast('Click two points at both end of the PTB bar, and push [CENTER].');
    } else if (val==3) {
      toast('Adjust the center position on both the Front/Back and Side views.');
    }
  });

  if (align.step == 0) {
    SetCameraFront()
  }

  function getActive(val){
    return (align.step == val) 
      ? `${style.button} ${style.buttonSelected}`
      : style.button;
  }

  return (
    <div className={style.outside}>
      {/* Menu */}

      <Grid container direction='column' justifyContent ='flex-start' alignItems='center'>
        <Grid item xs={12} className={style.subcategory}>Step</Grid>
      </Grid>

      <Grid container spacing={1} alignItems='center'>
        <Grid item xs={3}>
          <Button name="step" className={getActive(0)} onClick={() => onClick(0)} size="small" >0. Angle</Button>
        </Grid>
        <Grid item xs={3}>
          <Button name="step" className={getActive(1)} onClick={() => onClick(1)} size="small" >1. Set MPT</Button>
        </Grid>
        <Grid item xs={3}>
          <Button name="step" className={getActive(2)} onClick={() => onClick(2)} size="small" >2. PTB Bar</Button>
        </Grid>
        <Grid item xs={3}>
          <Button name="step" className={getActive(3)} onClick={() => onClick(3)} size="small" >3. Center</Button>
        </Grid>
      </Grid>
      <Form/> 
    </div>
  );
}
export default FormAlign;
